module.exports = __webpack_public_path__ + "img/plus-circle.ed7f70a0.svg";